export default [
  {
    path: 'minha-assinatura',
    name: 'subscription.my',
    meta: {
      title: 'Minha Assinatura',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "subscription.my" */ '../views/subscription/Subscription.vue')
  },
  {
    path: 'minha-assinatura/fatura/:charge',
    name: 'subscription.charge.show',
    meta: {
      title: 'Visualizando Fatura',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "subscription.charge.show" */ '../views/subscription/ShowCharge.vue')
  },
  {
    path: 'assinatura',
    name: 'subscription.plan',
    meta: {
      title: 'Meu Plano',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "subscription.plan" */ '../views/subscription/Plan.vue')
  },
  {
    path: 'assinatura/:plan',
    name: 'subscription.checkout',
    meta: {
      title: 'Checkout',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "subscription.checkout" */ '../views/subscription/CheckoutStripe.vue')
  }
]
